<template>
  <b-table
    :data="jobs"
    :striped="true"
    :narrowed="true"
    :hoverable="true"
    :sort-icon="'angle-up'"
    paginated
    per-page="20"
  >
    <b-table-column sortable field="id" :label="$t('id')" v-slot="props">
      {{ $t(props.row.id) }}
    </b-table-column>

    <b-table-column sortable field="name" :label="$t('name')" v-slot="props">
      {{ $t(props.row.name) }}
    </b-table-column>

    <b-table-column
      sortable
      field="created"
      :label="$t('created')"
      v-slot="props"
    >
      {{ $d(props.row.created, 'longlong') }}
    </b-table-column>

    <b-table-column
      sortable
      field="created"
      :label="$t('finished')"
      v-slot="props"
    >
      {{ props.row.finished ? $d(props.row.finished, 'longlong') : '' }}
    </b-table-column>

    <b-table-column
      width="10%"
      sortable
      field="error"
      :label="$t('error')"
      v-slot="props"
    >
      {{ $t(props.row.error) }}
    </b-table-column>

    <b-table-column v-slot="props">
      <b-tooltip v-if="props.row.id" :label="$t('view')" type="is-black">
        <b-button
          size="is-small"
          icon-left="eye"
          @click="(event) => $emit('view', props.row.id)"
        />
      </b-tooltip>
      <b-tooltip v-if="props.row.id" :label="$t('delete')" type="is-black">
        <b-button
          size="is-small"
          icon-left="trash"
          @click="(event) => $emit('delete', props.row.id)"
        />
      </b-tooltip>

      <b-tooltip v-if="props.row.id" :label="$t('refresh')" type="is-black">
        <b-button
          size="is-small"
          icon-left="sync"
          @click="(event) => $emit('refresh', props.row.id)"
        />
      </b-tooltip>
    </b-table-column>

    <section slot="empty" class="section">
      <div class="content has-text-grey has-text-centered">
        <p>
          <i class="fa fa-ban" style="font-size: 64px"></i>
        </p>
        <slot name="empty-actions">
          <p>{{ $t('no-job') }}</p>
        </slot>
      </div>
    </section>
  </b-table>
</template>

<script>
export default {
  name: 'JobsTable',
  props: {
    jobs: {
      type: Array,
      required: true
    }
  },
  emits: ['view', 'delete', 'refresh']
}
</script>
